import { Brand, Divider, CanvasTools, ElementTools, User } from '@starflow/app/components/navbar';
import { DownloadModal } from '@shakkerai/web-pro/src/components/DowloadModal';

export const rootComponents = [{ Component: DownloadModal }];

export const subWindowComponents = [];

export const navbarComponents = {
  left: [{ Component: Brand }, { Component: Divider }, { Component: CanvasTools }],
  center: [{ Component: ElementTools }],
  right: [{ Component: User }],
};

export const panelComponents = {
  left: [],
  bottom: [],
  right: [],
  element_info: [],
};
